import { useRef } from "react";
import { UserStateContext } from "./context";
import UserStore from "./store";

export function UserProvider({user, children }) {
  // Lazy aanmaken: useRef(new UserStore(user)) bouwt bij elke render een nieuwe store
  const storeRef = useRef<UserStore>();
  if(!storeRef.current)
    storeRef.current = new UserStore(user);

  const store = storeRef.current;

  return (
    <UserStateContext.Provider value={store}>
      {children}
    </UserStateContext.Provider>
  );
}